import React from 'react';
import { useCalendarNavigation } from '../context/CalendarNavigationContext';
import { getWeekDays } from '../utils/dateHelpers';
import { DAY_NAMES_PL } from '../utils/constants';

const MobileWeekStrip = ({
  selectedDay,
  onDaySelect,
  eventDays = [],
  className = '',
}) => {
  const { currentWeekStart } = useCalendarNavigation();
  const weekDays = getWeekDays(currentWeekStart);

  const hasEventsOnDay = (dayKey) => {
    return eventDays.includes(dayKey);
  };

  return (
    <div className={`calendar-mobile__week-strip ${className}`}>
      {weekDays.map((day) => {
        const isSelected = selectedDay && selectedDay.isSame(day.date, 'day');
        const hasEvents = hasEventsOnDay(day.key);

        return (
          <button
            key={day.key}
            type="button"
            className={`
              calendar-mobile__day-pill
              ${isSelected ? 'calendar-mobile__day-pill--selected' : ''}
              ${day.isToday ? 'calendar-mobile__day-pill--today' : ''}
              ${hasEvents ? 'calendar-mobile__day-pill--has-events' : ''}
            `}
            onClick={() => onDaySelect(day.date)}
          >
            <span className="calendar-mobile__day-name">
              {DAY_NAMES_PL[day.isoWeekday - 1]}
            </span>
            <span className="calendar-mobile__day-number">
              {day.dayNumber}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default MobileWeekStrip;
